/**
  Author: Lokech Arora - lokesh.arora@enabledata.com
  Purpose: Clients model actions
  Date: May 2020
**/

import { action, thunk } from 'easy-peasy';
import * as clientService from '../../services/client';

const clientModel = {
  clientList: [],
  isClientInfoLoaded: false,

  setClientList: action((state, payload) => {
    state.clientList = payload;
  }),

  clientListLoader: false,
  setClientListLoader: action((state, payload) => {
    state.clientListLoader = payload;
  }),

  getClientList: thunk(async (actions, payload) => {
    await clientService
      .getClientList(payload)
      .then(function (response) {
        actions.setClientListLoader(false);
        // actions.setIsClientInfoLoaded(true);
        actions.setClientList(response.data.data.items);
        return response;
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setClientListLoader(false);
        actions.setClientList([]);
        // actions.setIsClientInfoLoaded(true);
        return error;
      });
  }),
};

export default clientModel;
